import { render } from "./VetProfile.vue?vue&type=template&id=0589c8e8&scoped=true"
import script from "./VetProfile.vue?vue&type=script&lang=js"
export * from "./VetProfile.vue?vue&type=script&lang=js"

import "./VetProfile.vue?vue&type=style&index=0&id=0589c8e8&lang=css"
import "./VetProfile.vue?vue&type=style&index=1&id=0589c8e8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0589c8e8"]])

export default __exports__